/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './line-item-retail-product-modal.component.html';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';
import {RetailProductListPageComponent} from '../retail-product/retail-product-list-page.component';
import {LocalNetworkInfo} from '../../components/session/local-network-info';
import {CreativeApiService} from '../creative/creative-api.service';
import {firstValueFrom} from 'rxjs';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED, RetailProductListPageComponent],
  selector: 'adn-line-item-retail-product-modal',
  template
})
export class LineItemRetailProductModalComponent implements OnInit {
  lineItemId: string;
  onComplete: () => void;

  validationErrors: any[] = [];
  createHook: (refLayout: any, selection?: Record<string, any>) => Promise<void>;

  constructor(
    public bsModalRef: BsModalRef,
    private readonly creativeApi: CreativeApiService,
    private readonly localNetworkInfo: LocalNetworkInfo = new LocalNetworkInfo()) {
  }

  ngOnInit(): void {
    const merchantGuide = this.localNetworkInfo.getMerchantGuide();
    this.createHook = (refLayout: any, selection: Record<string, any> = {}) => {
      if (!refLayout?.id) {
        return Promise.resolve();
      }
      const allPromises: any[] = [];
      _.forEach(selection, (rp: any) => {
        const merchantLink = merchantGuide[rp.merchantId].link;
        allPromises.push(firstValueFrom(
          this.creativeApi.retailAd(this.lineItemId, '', refLayout.id, merchantLink, rp.itemId)
        ));
      });
      return Promise.all(allPromises).then(() => {
        this.onComplete?.();
        this.bsModalRef.hide();
      });
    };
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
